import { Form, InputNumber } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useContext } from "react";
import Authorization from "../../../../../component/Authorization";
import { DebounceSelect } from "../../../../../component/DebounceSelect";
import { IOModal } from "../../../../../component/Modal";
import {
  ProductInquiry,
  ProductUI,
} from "../../../product/entity/product.model";
import { productService } from "../../../product/service/product.service";
import { RouteContext } from "../../../user/screen/components/route.context";
import { PromotionProductUI } from "../../entity/promotion-product.model";
import { PromotionProductType } from "../../entity/promotion.model";
import PromotionProductTable from "./PromotionProductTable";

export interface EditPromotionProductsProps {
  value?: PromotionProductUI[];
  onChange?: (value: PromotionProductUI[]) => void;
  type: PromotionProductType;
}

function EditPromotionProducts(props: EditPromotionProductsProps) {
  const [form] = useForm();
  const { state } = useContext(RouteContext);

  const findIndexOfProduct = (_promotionProduct: PromotionProductUI) => {
    if (props.value && props.value.length > 0) {
      return props.value.findIndex(
        (x) => x.product.uuid === _promotionProduct.product.uuid
      );
    } else {
      return -1;
    }
  };

  const onDelete = (_promotionProduct: PromotionProductUI) => {
    let index = findIndexOfProduct(_promotionProduct);

    if (index !== -1) {
      let list = props.value ? [...props.value] : [];
      list.splice(index, 1);
      props.onChange && props.onChange(list);
    }
  };

  const onEdit = (_promotionProduct: PromotionProductUI) => {
    form.resetFields();
    form.setFieldsValue(_promotionProduct);

    IOModal.show({
      title: "Урамшууллын бүтээгдэхүүн засах",
      content: PromotionProductForm(),
      okText: "Хадгалах",
      onOk: () => {
        form.submit();
      },
    });
  };

  const onAdd = () => {
    form.resetFields();
    IOModal.show({
      title: "Урамшууллын бүтээгдэхүүн нэмэх",
      content: PromotionProductForm(),
      okText: "Хадгалах",
      onOk: () => {
        form.submit();
      },
    });
  };

  const onFinish = (value: PromotionProductUI) => {
    value.sale = 100;
    let index = findIndexOfProduct(value);
    let _list = props.value && props.value?.length > 0 ? [...props.value] : [];

    if (index !== -1) {
      _list[index] = value;
    } else {
      _list.push(value);
    }

    _list.forEach((x) => {
      x.productId = x.product.uuid;
    });

    props.onChange && props.onChange(_list);
    IOModal.hide();
  };

  const PromotionProductForm = () => {
    return (
      <Form form={form} onFinish={onFinish}>
        <div className="form-group">
          <label>Бүтээгдэхүүн:</label>
          <Form.Item
            name="product"
            rules={[
              {
                required: true,
                message: "Бүтээгдэхүүнийг сонгоно уу.",
              },
            ]}
          >
            <DebounceSelect<ProductUI>
              showSearch
              placeholder="Хайх"
              fetchOptions={async (search) => {
                let inquiry: ProductInquiry = {
                  page: 1,
                  pageSize: 100,
                  name: search,
                  routeId: state.routeId
                };
                let pagination = await productService.getProducts(inquiry);
                return pagination.results;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </div>
        {props.type === PromotionProductType.BENEFIT_PRODUCT && (
          <div className="form-group">
            <label>Тоо ширхэг:</label>
            <Form.Item
              name="count"
              rules={[
                {
                  required: true,
                  message: "Тоог оруулна уу.",
                },
              ]}
            >
              <InputNumber placeholder="Тоо оруулна уу" />
            </Form.Item>
          </div>
        )}
      </Form>
    );
  };

  return (
    <div>
      <div className="text-right pb-3">
        <Authorization roles={["promotion-full"]}>
          <button type="button" className="btn btn-primary" onClick={onAdd}>
            <i className="icon-plus2 pr-1"></i>
            {props.type === PromotionProductType.BENEFIT_PRODUCT
              ? "Урамшууллын"
              : "Худалдан авах"}{" "}
            бүтээгдэхүүн нэмэх
          </button>
        </Authorization>
      </div>

      <PromotionProductTable
        promotionProducts={props.value ?? []}
        onDelete={onDelete}
        onEdit={onEdit}
        type={props.type}
      />
    </div>
  );
}
export default EditPromotionProducts;
